import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
          <p className="text-sm text-foreground-600 mt-2">五大核心优势，打造最懂你的吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center group cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}